export default "__VITE_ASSET__SymhhVqS__"